import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const AuditTrailPage = lazy(() => import('~/features/configuration/pages/audit-trail-page'));

/**
 * Configuration Manager — Audit Trail tab at `/configuration/manager/audit-trail`.
 * Wrapped by the `/configuration/manager` layout (`manager.tsx`).
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/manager/audit-trail')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <AuditTrailPage />
    </Suspense>
  ),
});
